import { SimpleForm, useNotify, useRedirect, PasswordInput } from "react-admin";
import { Typography, Box } from "@mui/material";
import { Config } from "../Constants/Config";
import httpClient from "../Providers/httpClient";

let ChangePasswordView = () => {
    const notify = useNotify();
    const redirect = useRedirect();

    const validateChangePassword = (values) => {
        const errors = {};
        if (!values.current_password) {
            errors.current_password = "Current Password is required";
        }
        if (!values.new_password) {
            errors.new_password = "New Password is required";
        }
        if (!values.confirm_new_password) {
            errors.confirm_new_password = "Confirm New Password is required";
        }
        if (values.new_password !== values.confirm_new_password) {
            errors.confirm_new_password = "Password should be exactly same";
        }
        if (values.current_password === values.new_password) {
            errors.confirm_new_password = "New Password should be different";
        }
        return errors;
    };

    const changePassword = async (data) => {
        const url = Config.a3sUrl + "/user/password/update";
        const username = localStorage.getItem("user_name");
        const oldPassword = data.current_password;
        const newPassword = data.new_password;
        const body = JSON.stringify({
            username,
            oldPassword,
            newPassword,
        });
        const options = {
            method: "POST",
            body,
        };
        await httpClient(url, options).then((response) => {
            if (response.status < 200 || response.status >= 300) {
                notify("Password change has failed", "warning");
            } else {
                redirect("/");
                notify("Password has successfully updated", "success");
            }
        });
    };

    return (
        <SimpleForm validate={validateChangePassword} onSubmit={changePassword}>
            <Typography variant="h6" gutterBottom>
                Change Password
            </Typography>
            <Box display={{ xs: "block", sm: "flex" }}>
                <Box flex={1} mr={{ xs: 0, sm: "0.5em" }}>
                    <PasswordInput source="current_password" fullWidth />
                </Box>
                <Box flex={1} mr={{ xs: 0, sm: "0.5em" }}>
                    <PasswordInput source="new_password" fullWidth />
                </Box>
                <Box flex={1} ml={{ xs: 0, sm: "0.5em" }}>
                    <PasswordInput source="confirm_new_password" fullWidth />
                </Box>
            </Box>
        </SimpleForm>
    );
};

export default ChangePasswordView;
